"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceResize = exports.MediaQueries = void 0;
var react_1 = require("react");
exports.MediaQueries = {
    mobile: 'only screen and (max-width: 920px)',
    tablet: 'only screen and (max-width: 767px)',
    desktop: '(min-width : 1224px)',
};
var useDeviceResize = function (query) {
    if (typeof window !== 'object')
        return false;
    if (!window.matchMedia)
        return false;
    var queryToMatch = exports.MediaQueries[query] || query;
    var _a = react_1.useState(window.matchMedia(queryToMatch).matches), matches = _a[0], setMatches = _a[1];
    react_1.useEffect(function () {
        var media = window.matchMedia(queryToMatch);
        if (media.matches !== matches)
            setMatches(media.matches);
        var listener = function () { return setMatches(media.matches); };
        if (media.addEventListener) {
            media.addEventListener('change', listener);
        }
        else
            media.addListener(listener);
        return function () {
            return media.removeEventListener
                ? media.removeEventListener('change', listener)
                : media.removeListener(listener);
        };
    }, [matches, queryToMatch]);
    return matches;
};
exports.useDeviceResize = useDeviceResize;
